export default __webpack_public_path__ + "static/media/Musobeks Shazam Music Finder.5b64ea6a.jpg";